import styled from '@xstyled/styled-components'

export const ShopPageViewWrapper = styled.div`
  background-color: white;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0 0 9 0;
  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
    padding: 0 0 6 0;
  }
`

export const ShopPageProductBlockWrapper = styled.div`
  padding: 9 6;
  margin: 0 auto;
  max-width: 800px;
  text-align: center;

  a {
    text-decoration: none;
  }
  .product_thumb {
    max-height: 70vh;
    height: auto;
    max-width: 100%;
    width: auto;
    object-fit: contain;
  }
  @media screen and (max-width: 1024px) {
    padding: 9 2;
    .product_thumb {
      max-height: 80vh;
      height: auto;
      max-width: 100%;
      width: auto;
      object-fit: contain;
    }
    h2 {
      font-size: 5;
    }
  }
  @media screen and (max-width: 480px) {
    padding: 6 1;
    .product_thumb {
      max-height: 90vh;
    }
    h2 {
      font-size: 6;
    }
  }
`
